
import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import { Card, CardHeader, CardBody, Row, Col, FormGroup, Label, CustomInput, Input } from 'reactstrap';

import { alertService } from 'components/Varios/alert_service.js';

import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";

import FileUpload from "components/Varios/FileUpload.js";
import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";
import Icon from "components/Varios/Icons.js";
import { authenticationService } from '../services/authentication.service';
import { UserData } from './Sidebar/Sidebar_Principal';
import Cargando from './Varios/Cargando';

const id = 649920;
const API_URL = configData.SERVER_URL

const ID_TIPO_ETNIA_INDIGENA = 'I'

export class DatosGeneralesData {
    nombres: string = "";
    apellidos: string = "";
    //fechavencimiento: Date = new Date();

    email: string = "";
    idlugarnacimiento: number = 0;

    idpersona: number = 0;
    idnacionalidad: number = 0;
    tipoidentificacion: string = "";
    numeroidentificacion: string = "";
    estadocivil: string = "";
    sexo: string = "";
    emailalterno: string = "";
    tienediscapacidad: string = "";
    etnia: string = "";
    generoautoidentificacion: string = "";
    genero: string = "";
    fechanacimiento: string = "";;
    tienefamildiscapacidad: string = "";
    estadopersona: string = "";
    conyugue: string = "";
    cuentali: string = "";
    pagweb: string = "";
}

export class LugarNacimientoData {
    idlugarnacimiento: number = 0;
    idcanton: number = 0;
    idprovincia: number = 0;
    idpais: number = 0;
    idpersona: number = 0;
}

export class HojaVidaData {
    idhojavida: number = 0;
    idpersona: number = 0;
    fechavencimientoidentif: string = "";
    username: number = 0;
    nacionalidad: string = "";
    nacionalidadIndigena?: number = undefined;
    refarchivoced: string = "";
    refarchivopass: string = "";
    refarchivovot: string = "";
    refarchivocarnet: string = "";
}

interface DatosGeneralesDataState {
    currentUser: any,
    loading: boolean;
    dtoData: DatosGeneralesData;
    ltoData: LugarNacimientoData;
    htoData: HojaVidaData;
    paisList: Array<any>;
    provinciaList: Array<any>;
    ciudadList: Array<any>;
    nacionalidadList: Array<any>;
    nacionalidadIndigenaList: Array<any>;
    identificacionEtnicaList: Array<any>;
    estadoCivilList: Array<any>;
    sexoList: Array<any>;
    identificacionGeneroList: Array<any>;
    startDate: Date;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
    solicitudActualizacion: boolean;
    cargado: boolean[];
}

export class DatosGenerales extends React.Component<RouteComponentProps<{}>, DatosGeneralesDataState> {
    constructor(props) {
        super(props);

        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true,
            dtoData: new DatosGeneralesData(), ltoData: new LugarNacimientoData(), htoData: new HojaVidaData(),
            paisList: [], provinciaList: [], ciudadList: [], nacionalidadList: [], nacionalidadIndigenaList: [], identificacionEtnicaList: [],
            estadoCivilList: [], sexoList: [], identificacionGeneroList: [], startDate: new Date(), error: null,
            tiposEvidencia: [], filesData: [], solicitudActualizacion: false, cargado: []
        };

        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarProvincias = this.cargarProvincias.bind(this);
        this.cargarCantones = this.cargarCantones.bind(this);
        this.cargarAutoIdentificacionGenero = this.cargarAutoIdentificacionGenero.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
        this.helperFindNacionalidad = this.helperFindNacionalidad.bind(this);
        // this.ActualizarFecha = this.ActualizarFecha.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {

        //API PARA OBTENER PAISES
        fetch(API_URL + "DatosGenerales/Paises")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            paisList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nombre
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los países.")
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        paisList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER NACIONALIDADES
        fetch(API_URL + "DatosGenerales/Nacionalidades")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            nacionalidadList: result.entTabla.map(d => ({
                                "value": d.idpais,
                                "label": d.nacionalidad
                            })),

                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las nacionalidades.")
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        nacionalidadList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER NACIONALIDADES INDIGENAS
        fetch(API_URL + "DatosGenerales/NacionalidadIndigena")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            nacionalidadIndigenaList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion.toUpperCase()
                            })),

                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las nacionalidades.")
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        nacionalidadIndigenaList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )



        //API PARA OBTENER ETNIAS
        fetch(API_URL + "DatosGenerales/TipoEtnia")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            identificacionEtnicaList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion.toUpperCase()
                                //"label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las étnias.")
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        identificacionEtnicaList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER ESTADOS CIVIL
        fetch(API_URL + "DatosGenerales/EstadoCivil")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            estadoCivilList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los estados civiles.")
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        estadoCivilList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER SEXOS
        fetch(API_URL + "DatosGenerales/Sexo")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            sexoList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los sexos.")
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        sexoList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER PERSONA
        fetch(API_URL + "DatosGenerales/PersonaId/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.cargarAutoIdentificacionGenero(result.entTabla[0]['sexo']);
                        let filesData = this.state.filesData;
                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(result.entTabla[0]['tipoidentificacion'], filesData),
                            cargado: [true]
                        });

                    } else if (result.strEstado === "N") {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los datos de la persona.")
                        this.setState({
                            cargado: [true]
                        })
                    }
                    else {
                        alertService.error("Ocurrió un error: " + result)
                        this.setState({
                            cargado: [true]
                        })
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new DatosGeneralesData(),
                        cargado: [true]
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER LUGAR DE NACIMIENTO
        fetch(API_URL + "DatosGenerales/LugarNacimientoIdPersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        if (result.entTabla.length != 0) {
                            this.setState({
                                ltoData: result.entTabla[0],
                                loading: false
                            });

                            if (result.entTabla[0]["idpais"]) {
                                this.cargarProvincias(result.entTabla[0]["idpais"], false)
                                this.cargarCantones(result.entTabla[0]["idprovincia"], false)
                            }
                        }


                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener el lugar de nacimiento de la persona.")
                        this.setState({
                            loading: false,
                            ltoData: new LugarNacimientoData()
                        });
                    }

                    this.setState({
                        loading: false,
                    });
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        ltoData: new LugarNacimientoData()
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        fetch(API_URL + "DatosSalud/HojaVidaByIdPersona/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        if (result.entTabla.length != 0) {
                            this.setState({
                                htoData: result.entTabla[0],
                                loading: false
                            });
                        }

                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener la hoja de vida.")
                    }
                },
                (error) => {

                    this.setState({
                        error,
                        htoData: new HojaVidaData()
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

    }

    cargarProvincias(idPais, change = true) {
        var lto = this.state.ltoData;
        var ciudadList = this.state.ciudadList;
        lto["idpais"] = idPais;
        if (change) {
            lto["idprovincia"] = 0;
            lto["idcanton"] = 0;
            ciudadList = []
        }

        this.setState({
            ltoData: lto,
            ciudadList: ciudadList
        });

        fetch(API_URL + "DatosGenerales/ProvinciaIdPais/" + idPais)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            provinciaList: result.entTabla.map(d => ({
                                "value": d.idprovincia,
                                "label": d.nombre
                            })),
                            loading: false
                        });
                    } else if (result.strEstado === "N") {
                        alertService.error("Ocurrió un error al obtener las provincias.")
                    }
                    else {
                        alertService.error("Ocurrió un error al obtener las provincias.")
                    }
                },

                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        provinciaList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarCantones(idProvincia, change = true) {
        var lto = this.state.ltoData;
        lto["idprovincia"] = idProvincia;
        if (change) {
            lto["idcanton"] = 0;
        }

        this.setState({
            ltoData: lto,
        });

        fetch(API_URL + "DatosGenerales/CantonIdProvincia/" + idProvincia)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            ciudadList: result.entTabla.map(d => ({
                                "value": d.idcanton,
                                "label": d.nombre
                            })),
                            loading: false
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los cantones.")
                    }
                },

                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        ciudadList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarAutoIdentificacionGenero(sexo) {
        this.handleSelectChange(sexo, "sexo")

        //API PARA OBTENER GENEROS
        fetch(API_URL + "DatosGenerales/AutoIdentificacionGenero")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {

                        var identificacionesGenero = result.entTabla.map(d => ({
                            "value": d.codigostr.trim(),
                            "label": d.descripcion
                        }))

                        for (var i = 0; i < identificacionesGenero.length; i++) {
                            if (sexo === 'F') {
                                if (identificacionesGenero[i]['value'] == 'M') {
                                    identificacionesGenero.splice(i, 1);
                                }

                            }
                            else if (sexo === 'M') {
                                if (identificacionesGenero[i]['value'] == 'F') {
                                    identificacionesGenero.splice(i, 1);
                                }
                            }
                        }

                        this.setState({
                            identificacionGeneroList: identificacionesGenero,
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener las identificaciones de género.")
                    }
                },
                (error) => {

                    this.setState({
                        loading: false,
                        error,
                        identificacionGeneroList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )
    }

    cargarEvidencias(tipoIdentificacion, filesData: any[]) {
        var tiposEvidencia;
        if (tipoIdentificacion === "CED") {
            tiposEvidencia = [
                { "value": "CED", "label": "Cédula" + filesData.filter(f => f.type == "CED").map(ff => ': ' + ff.file.name).join(', ') },
                { "value": "VOT", "label": "Cert. votación" + filesData.filter(f => f.type == "VOT").map(ff => ': ' + ff.file.name).join(', ') }
            ];
        } else if (tipoIdentificacion === "PAS") {
            tiposEvidencia = [
                { "value": "PAS", "label": "Pasaporte" + filesData.filter(f => f.type == "PAS").map(ff => ': ' + ff.file.name).join(', ') }
            ];
        }
        return tiposEvidencia;
    }

    descargarEvidencias(hojavida: HojaVidaData) {
        var evidencias = new Array();
        var dto = this.state.dtoData;
        if (hojavida.refarchivoced) {
            evidencias.push({ name: "CED" + dto.numeroidentificacion + ".PDF", url: API_URL + "DatosGenerales/Refarchivo/CED/" + hojavida.idpersona });
        }
        if (hojavida.refarchivopass) {
            evidencias.push({ name: "PAS" + dto.numeroidentificacion + ".PDF", url: API_URL + "DatosGenerales/Refarchivo/PAS/" + hojavida.idpersona });
        }
        if (hojavida.refarchivovot) {
            evidencias.push({ name: "VOT" + dto.numeroidentificacion + ".PDF", url: API_URL + "DatosGenerales/Refarchivo/VOT/" + hojavida.idpersona });
        }
        return evidencias;
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        dto[event.target.name] = event.target.value;
        this.setState({
            dtoData: dto,
            loading: false
        })
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);
        let tipoIdentificacion = this.state.dtoData.tipoidentificacion;
        this.setState({
            filesData: fileInfoState,
            tiposEvidencia: this.cargarEvidencias(tipoIdentificacion, fileInfoState)
        });
    }

    handleSelectChange(value, name) {
        if (name === 'fechavencimientoidentif') {
            var hto = this.state.htoData;
            hto[name] = value;
            this.setState({ htoData: hto });
        }

        else if (name === 'idcanton') {
            var lto = this.state.ltoData;
            lto[name] = value;
            this.setState({ ltoData: lto });
        }
        else if (name === "nacionalidadIndigena") {
            var hto = this.state.htoData;
            hto[name] = value;
            this.setState({ htoData: hto });
        }

        else {
            var dto = this.state.dtoData;
            dto[name] = value;
            this.setState({ dtoData: dto });
        }


    }

    toggleCheckbox(event) {
        this.setState(
            {
                solicitudActualizacion: !this.state.solicitudActualizacion,
            }
        );
    }

    helperFindNacionalidad(idNacionalidadIndigena: number, listadoSelectNacionalidadIndigena: Array<{ label: string, value: string }>) {
        var nacionalidadSeleccionado = listadoSelectNacionalidadIndigena.find((valoresSelect, indice) => {
            return valoresSelect.value.toString() === idNacionalidadIndigena.toString()
        })

        return nacionalidadSeleccionado ? nacionalidadSeleccionado.value : undefined
    }

    private handleSave(event) {

        //type PropType<TObj, TProp extends keyof TObj> = TObj[TProp];        
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = this.state.dtoData;
        var lto = this.state.ltoData;
        var hto = this.state.htoData;
        var filesData = this.state.filesData;
        let formIsValid = true;




        forma.forEach((value, clave) => {
            if (!value && (clave !== "evidencias" && clave !== "cuentali" && clave !== "pagweb")) {
                formIsValid = false;
            }
            if (clave === "fechavencimientoidentif" && dto.tipoidentificacion === "PAS" && !value) {
                formIsValid = false
            }
            if (clave === 'etnia' && dto["etnia"] !== ID_TIPO_ETNIA_INDIGENA) {
                hto["nacionalidadIndigena"] = undefined
            }

            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;


            if (typeof lto[clave] === 'number') {
                lto[clave] = Number(value);
            }
            else if (typeof lto[clave] === 'boolean') {
                lto[clave] = Boolean(value);
            }
            else
                lto[clave] = value;

            //DATOS PARA TABLA  HOJA DE VIDA, CAMBIOS AL MOMENTO DE ENVIAR
            if (typeof hto[clave] === 'number') {
                hto[clave] = Number(value);
            }
            else if (typeof hto[clave] === 'boolean') {
                hto[clave] = Boolean(value);
            }
            else
                hto[clave] = value;


            if (clave === 'fechanacimiento') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }

            if (clave === 'fechavencimientoidentif') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                hto[clave] = date.toJSON();
            }



        });

        dto.idpersona = this.state.currentUser.idpersona;
        lto.idpersona = this.state.currentUser.idpersona;
        hto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "tpersona": dto, "tlugarnacimiento": lto, "thojavida": hto
        });

        if (formIsValid) {
            //fetch(API_URL + "FormularioController/PostDatosGenerales", {
            fetch(API_URL + "FormularioController/PostDatosGeneralesTransaccion", {

                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,

            })
                .then(response => response.json())
                .then(
                    (result) => {
                        if (result["strEstado"] === "N") {
                            alertService.error(result["strMensaje"])
                        }
                        else if (result["strEstado"] === "S") {
                            alertService.success("La sección de Datos Generales ha sido actualizada correctamente.")
                            authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())
                            const persona = JSON.stringify({
                                "entidad": String(this.state.dtoData.idpersona)
                            });

                            if (this.state.solicitudActualizacion) {
                                fetch(API_URL + "FormularioController/PostSolicitudActualizacion", {
                                    method: 'POST',
                                    body: persona
                                })
                                    .then(response => response.json())
                                    .then(success => {
                                        // Do something with the successful response
                                    })
                                    .catch(error => alertService.error(error) //console.log(error)
                                    );
                            }

                            this.setState(
                                {
                                    solicitudActualizacion: false,
                                }
                            );

                            if (filesData.length > 0) {
                                var formFilesData = new FormData();

                                filesData.map((fileData) => {
                                    formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                });

                                formFilesData.append('idhojavida', result.thojavida.idhojavida);

                                fetch(API_URL + "FormularioController/PostFilesDatosGenerales", {
                                    method: 'POST',
                                    body: formFilesData
                                })
                                    .then(response => response.json())
                                    .then(success => {
                                        // Do something with the successful response
                                    })
                                    .catch(error => alertService.error(error) //console.log(error)
                                    );
                            }

                            var hto = result["thojavida"]
                            var fecha = new Date(hto.fechavencimientoidentif)
                            fecha.setDate(fecha.getDate() + 1);
                            hto.fechavencimientoidentif = String(fecha)
                            this.setState({
                                dtoData: result["tpersona"],
                                htoData: result["thojavida"],
                                ltoData: result["tlugarnacimiento"]
                            });
                        }
                        else {
                            alertService.error(result);
                        }

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);
                    },
                    (error) => {
                        alertService.error("Ocurrió un error: " + error)
                    }
                )
        } else {
            alertService.error("Por favor seleccione/complete todos los campos.");
        }


    }


    public render() {


        if (this.state.cargado.length === 0) {
            return <Cargando />
        }
        let contents = this.state.loading || !(this.state.currentUser || this.state.currentUser.idpersona > 0)

            ?
            <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.paisList, this.state.provinciaList, this.state.ciudadList, this.state.nacionalidadList, this.state.nacionalidadIndigenaList, this.state.identificacionEtnicaList, this.state.estadoCivilList, this.state.sexoList, this.state.identificacionGeneroList, this.state.startDate, this.state.tiposEvidencia);

        return <div className="content">

            {contents}

        </div>;

    }



    // Returns the HTML Form to the render() method.  

    private renderForm(paisList: Array<any>, provinciaList: Array<any>, ciudadList: Array<any>, nacionalidadList: Array<any>, nacionalidadIndigenaList: Array<any>, identificacionEtnicaList: Array<any>, estadoCivilList: Array<any>, sexoList: Array<any>, identificacionGeneroList: Array<any>, startDate: Date, tiposEvidencia: Array<any>) {

        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">DATOS GENERALES</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div>

                                    <form onSubmit={this.handleSave} id="formDatosGenerales">
                                        <Row form id="RowFormDGDatosNombres">
                                            <Col sm={12} md={9} lg={6}>
                                                <FormGroup >
                                                    <Label for="nombres_apellidos">Nombres / Apellidos*</Label>
                                                    <Input className="form-control-plaintext" readOnly type="text" value={this.state.dtoData.nombres + " " + this.state.dtoData.apellidos} required />
                                                </FormGroup>

                                            </Col>
                                        </Row>

                                        <Row form id="RowFormDGInformacionNacimiento">
                                            <Col sm={12} md={4} lg={4} xl={3}>
                                                <FormGroup>
                                                    <Label className=" control-label " htmlFor="fechanacimiento">Fecha nacimiento*</Label>
                                                    <Datepicker
                                                        value={this.state.dtoData.fechanacimiento}
                                                        name="fechanacimiento"
                                                        id="fechanacimiento"
                                                        placeholder="Fecha nacimiento"
                                                        onChange={this.handleSelectChange}
                                                        disabled={true}
                                                    />
                                                </FormGroup>

                                            </Col>

                                            <Col sm={12} md={8} lg={8} xl={6}>
                                                <FormGroup>
                                                    <Label className=" control-label " htmlFor="pais">Lugar de nacimiento: <strong>Pais/Provincia/Ciudad*</strong></Label>
                                                    <FormGroup row className="groupRowEvidenciasDatosGenerales">
                                                        <SelectItem
                                                            options={paisList}
                                                            value={this.state.ltoData.idpais}
                                                            onChange={this.cargarProvincias}
                                                            placeholder="País"
                                                            name="idpais"
                                                            id="idpais"
                                                            icon="pais"
                                                            disabled={true}
                                                            rowRender={true}
                                                        />
                                                        <SelectItem
                                                            options={provinciaList}
                                                            value={this.state.ltoData.idprovincia}
                                                            onChange={this.cargarCantones}
                                                            placeholder="Provincia"
                                                            name="idprovincia"
                                                            id="provincia"
                                                            icon="ubicacion"
                                                            disabled={true}
                                                            rowRender={true}

                                                        />
                                                        <SelectItem
                                                            options={ciudadList}
                                                            value={this.state.ltoData.idcanton}
                                                            placeholder="Ciudad"
                                                            name="idcanton"
                                                            id="ciudad"
                                                            //icon="fa-map-marker-alt"
                                                            icon="ubicacion"
                                                            onChange={this.handleSelectChange}
                                                            disabled={true}
                                                            rowRender={true}

                                                        />
                                                    </FormGroup>
                                                </FormGroup>

                                            </Col>

                                        </Row>

                                        <Row form id="RowFormDGIdentificacion">
                                            <Col sm={12} md={2} lg={1}>
                                                <FormGroup >
                                                    <Label for="identificacion" >Identificación*</Label>

                                                    {
                                                        this.state.dtoData.tipoidentificacion === "CED" ?
                                                            <CustomInput
                                                                // className="col-md-2 mt-1"
                                                                type="radio"
                                                                checked={this.state.dtoData.tipoidentificacion === "CED"}
                                                                value="CED"
                                                                id="tipoidentificacion"
                                                                name="tipoidentificacion"
                                                                onChange={this.handleChange}
                                                                label="Cédula"
                                                                disabled={true}
                                                            />
                                                            :
                                                            <CustomInput
                                                                // className="col-md-2 mt-1"
                                                                type="radio"
                                                                value="PAS"
                                                                id="tipoidentificacion2"
                                                                name="tipoidentificacion"
                                                                checked={this.state.dtoData.tipoidentificacion === "PAS"}
                                                                onChange={this.handleChange}
                                                                label="Pasaporte"
                                                                disabled={true}
                                                            />
                                                    }





                                                </FormGroup>
                                            </Col>
                                            <Col sm={12} md={2} lg={2} xl={2} className="mt-1">
                                                <FormGroup >
                                                    <Label></Label>
                                                    <Input className="form-control-plaintext" readOnly type="text" name="numeroidentificacion" id="identificacion" placeholder="Cédula o Pasaporte" defaultValue={this.state.dtoData.numeroidentificacion} required />

                                                </FormGroup>
                                            </Col>

                                            <Col sm={12} md={3} lg={2} xl={2}>
                                                <FormGroup >
                                                    <Label for="fechavencimientoidentif" >Fecha de caducidad*</Label>
                                                    <Datepicker
                                                        value={this.state.htoData.fechavencimientoidentif}
                                                        name="fechavencimientoidentif"
                                                        id="fechavencimientoidentif"
                                                        placeholder="Fecha caducidad identificación"
                                                        onChange={this.handleSelectChange}
                                                        disabled={this.state.dtoData.tipoidentificacion === "CED"}
                                                    />
                                                </FormGroup>
                                            </Col>


                                            {this.state.dtoData.tipoidentificacion === "CED" &&
                                                <Col xs={12} sm={12} md={3} lg={3} xl={2}>

                                                    <Label for="fechavencimientoidentif" >Evidencia cédula*</Label>
                                                   
                                                        <div className="containerEvidenciaDG">
                                                            <InputFileUpload className="firstevidencia" icon="upload" onChange={this.handleFileUploadChange} name="CED" placeholder={this.state.htoData.refarchivoced ? "Subir cédula" : "Subir cédula"} />
                                                            <InputFileDownload className="secondevidencia" noColumnStyle={true} tipo="cédula" id="downloadCed" refarchivo={this.state.htoData.refarchivoced} name={"CED" + this.state.dtoData.numeroidentificacion + ".PDF"} url={API_URL + "DatosGenerales/Refarchivo/CED/" + this.state.htoData.idpersona} icon="download" />

                                                        </div>
                                                    
                                                    



                                                </Col>
                                            }
                                            {this.state.dtoData.tipoidentificacion === "CED" &&
                                                <Col xs={12} sm={12} md={3} lg={3} xl={2}>
                                                        <Label for="fechavencimientoidentif" >Evidencia papeleta de votación*</Label>
                                                        <div className="containerEvidenciaDG">

                                                        <InputFileUpload  className="firstevidencia" icon="upload" onChange={this.handleFileUploadChange} name="VOT" placeholder={this.state.htoData.refarchivovot ? "Subir papeleta de votación" : "Subir papeleta de votación"} />
                                                        <InputFileDownload  className="secondevidencia" noColumnStyle={true} tipo="paleta de votación" id="downloadVot" refarchivo={this.state.htoData.refarchivovot} name={"VOT" + this.state.dtoData.numeroidentificacion + ".PDF"} url={API_URL + "DatosGenerales/Refarchivo/VOT/" + this.state.htoData.idpersona} icon="download" />
                                                        </div>
                                                </Col>
                                            }
                                            {
                                                this.state.dtoData.tipoidentificacion !== "CED" &&
                                                <Col xs={12} sm={12} md={3} lg={4} xl={3}>
                                                    <FormGroup >
                                                        <Label for="fechavencimientoidentif" >Evidencia pasaporte*</Label>
                                                        <FormGroup row>
                                                            <InputFileUpload icon="upload" onChange={this.handleFileUploadChange} name="PAS" placeholder={this.state.htoData.refarchivopass ? "Subir pasaporte" : "Subir pasaporte"} />
                                                            <InputFileDownload noColumnStyle={true} tipo="pasaporte" id="refarchivopass" refarchivo={this.state.htoData.refarchivopass} name={"PAS" + this.state.dtoData.numeroidentificacion + ".PDF"} url={API_URL + "DatosGenerales/Refarchivo/PAS/" + this.state.htoData.idpersona} icon="download" />
                                                        </FormGroup>
                                                    </FormGroup>
                                                </Col>
                                            }


                                        </Row>

                                        <Row form id="RowFormDGNacionalidad">
                                            <Col sm={12} md={4} lg={4}>
                                                <FormGroup>
                                                    <Label className="control-label" htmlFor="nacionalidad">Nacionalidad*</Label>
                                                    <SelectItem
                                                        options={nacionalidadList}
                                                        value={this.state.dtoData.idnacionalidad}
                                                        placeholder="Nacionalidad"
                                                        name="idnacionalidad"
                                                        id="idnacionalidad"
                                                        icon="identidad"
                                                        onChange={this.handleSelectChange}
                                                        disabled={true}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            
                                        </Row>

                                        <Row form id="RowFormDGInformacionPrivadaSG">
                                            <Col sm={12} md={4} lg={4}>
                                                <FormGroup>
                                                    <Label className=" control-label " htmlFor="sexo">Sexo*</Label>
                                                    <SelectItem
                                                        options={sexoList}
                                                        value={this.state.dtoData.sexo}
                                                        placeholder="Sexo"
                                                        name="sexo"
                                                        id="sexo"
                                                        //icon="fa-venus-mars"
                                                        icon="sexo"
                                                        onChange={this.cargarAutoIdentificacionGenero}
                                                        disabled={true}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm={12} md={4} lg={4}>
                                                <FormGroup>
                                                    <Label className=" control-label " htmlFor="identificacion_genero">Auto identificación de género</Label>
                                                    <SelectItem
                                                        options={identificacionGeneroList}
                                                        value={this.state.dtoData.generoautoidentificacion}
                                                        placeholder="Identificación de género"
                                                        name="generoautoidentificacion"
                                                        id="generoautoidentificacion"
                                                        icon="autoidentificacion_genero"
                                                        onChange={this.handleSelectChange}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row form id="RowFormDGInformacionPrivada">

                                            <Col sm={12} md={4} lg={4}>
                                                <FormGroup>
                                                    <Label className=" control-label " htmlFor="estado_civil">Estado civil*</Label>
                                                    <SelectItem
                                                        options={estadoCivilList}
                                                        value={this.state.dtoData.estadocivil}
                                                        placeholder="Estado civil"
                                                        name="estadocivil"
                                                        id="estado_civil"
                                                        //icon="fa-heart"
                                                        icon="estado_civil"
                                                        onChange={this.handleSelectChange}
                                                        disabled={true}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            {
                                                this.state.dtoData.estadocivil === "C" &&
                                                <Col sm={12} md={4} lg={4}>
                                                    <FormGroup>
                                                        <Label className=" control-label" htmlFor="conyugue">Cónyugue</Label>
                                                        <Input className="form-control-plaintext" readOnly type="text" defaultValue={this.state.dtoData.conyugue} />
                                                    </FormGroup>
                                                </Col>

                                            }





                                        </Row>

                                        <Row form id="RowFormDGEmails">
                                            <Col sm={12} md={4} lg={4}>
                                                <FormGroup>
                                                    <Label className=" control-label " htmlFor="email_espol">Email ESPOL*</Label>
                                                    <Input style={{ textTransform: "lowercase" }} className="form-control-plaintext" readOnly type="email" name="email_espol" defaultValue={this.state.dtoData.email} />

                                                </FormGroup>
                                            </Col>
                                            <Col sm={12} md={4} lg={4}>
                                                <FormGroup>
                                                    <Label className=" control-label " htmlFor="email_personal">Email personal*</Label>
                                                    <Input style={{ textTransform: "lowercase" }} className="form-control-plaintext" required type="email" name="emailalterno" placeholder="Email personal" defaultValue={this.state.dtoData.emailalterno} />

                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row form id="RowFormCuentas">
                                            <Col sm={12} md={4} lg={4}>
                                                <FormGroup>
                                                    <Label className=" control-label " htmlFor="sitio_web">Sitio web</Label>
                                                    <Input style={{ textTransform: "lowercase" }} className="form-control-plaintext" type="text" name="pagweb" placeholder="Sitio Web" defaultValue={this.state.dtoData.pagweb} />

                                                </FormGroup>
                                            </Col>
                                            <Col sm={12} md={4} lg={4}>
                                                <FormGroup>
                                                    <Label className=" control-label " htmlFor="cuenta_linkldn">Cuenta LinkedIn</Label>
                                                    <Input style={{ textTransform: "lowercase" }} className="form-control-plaintext" type="text" name="cuentali" placeholder="Cuenta LinkedIn" defaultValue={this.state.dtoData.cuentali} />

                                                </FormGroup>
                                            </Col>

                                        </Row>


                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox" onChange={this.toggleCheckbox} />{' '}
                                                Solicito a la Dirección de Talento Humano, actualizar mi información con
                                                los datos que se encuentran en el Registro Civil del Ecuador
                                            </Label>
                                        </FormGroup>
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-default">Guardar</button>
                                        </div >

                                    </form >
                                    {
                                        //<ModalInformativo
                                        //    contenido="Si existe información incorrecta que no sea posible modificar, 
                                        //        por favor enviar un correo a la dirección electrónica uath@espol.edu.ec, 
                                        //        adjuntando la documentación de soporte respectiva, para que nuestros analistas 
                                        //        puedan gestionar la correcta actualización de su información."
                                        //    isOpen={this.state.isOpenModal}
                                        //    onAcept={this.handleModalChange}

                                        ///>
                                    }

                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default DatosGenerales;